export const specialCases = Object.freeze({
  facility: 'facilities'
})

export default function pluralize(singular, quantity) {
  if (quantity === 1) return singular
  return specialCases[singular.toLowerCase()] || `${singular}s`
}
